<template>

<fragment>

<core-filter-advanced-builder-logic :logic="group.logic" :is-first="index === 1" v-on:change="onLogicChange" v-if="level > 1" />

<div class="group" :data-level="level" :class="{'is-over': is.over}">

    <template v-for="(rule, ruleIndex) in group.rules">

        <core-filter-advanced-builder-rule :rule="rule" :index="ruleIndex + 1" :level="level + 1" :key="ruleIndex + 'r'" v-if="rule.rule" />
        <core-filter-advanced-builder-group :group="rule" :index="ruleIndex + 1" :level="level + 1" :key="ruleIndex + 'g'" v-if="rule.rules" />

    </template>
    
    <div class="group-button" v-tooltip="tooltip" v-on:click="onClick" v-click-outside="onOutsideClick" v-on:mouseenter="onMouseEnter" v-on:mouseleave="onMouseLeave">
    
        <i class="fa-solid fa-ellipsis-vertical" v-if="level > 1" />
        <i class="fa-solid fa-plus" v-if="level === 1" />
    
    </div>

    <core-filter-advanced-builder-dropdown :options="options" class="group-dropdown" v-on:change="onDropdownClick" v-if="expanded" />

</div>

</fragment>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    props: ['level', 'index', 'group'],

    data: function() {

        return {
            expanded: false,
            is: {
                over: false
            }
        }

    },

    computed: {

        tooltip: function() {

            return (this.level === 1) ? 'Add top level rule' : 'Manage group'

        },

        options: function() {

            var options = [
                { value: 'rule.add', text: 'Add rule' }
            ]

            if (this.level < 4) {

                options.push({ value: 'group.add', text: 'Add sub-group' })

            }

            if (this.level > 1) {

                options.push({ value: 'group.remove', text: 'Remove group' })

            }

            return options

        }

    },

    methods: {

        onOutsideClick: function() {

            this.expanded = false

        },

        onLogicChange: function(value) {

            this.$pubsub.$emit('filter.logic.change', {
                id: this.group.id,
                logic: value
            })

        },

        onDropdownClick: function(value) {

            if (value === 'rule.add') {

                this.$pubsub.$emit('open.modal', {
                    id: 'filterDirectory',
                    group: this.group.id
                })

            } else if (value === 'group.add') {

                this.$pubsub.$emit('filter.group.add', {
                    group: this.group.id
                })

            } else if (value === 'group.remove') {

                this.$pubsub.$emit('filter.group.remove', {
                    id: this.group.id
                })

            }

            this.expanded = false

        },

        onClick: function() {

            this.expanded = !this.expanded

        },

        onMouseEnter: function() {

            this.is.over = true

        },

        onMouseLeave: function() {

            this.is.over = false

        }

    }

}

</script>

<style scoped>

.group {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: 1fr;
    padding: 15px 15px 33px 15px;
    margin-bottom: 18px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.2);
}

.group[data-level="1"] {
    background-color: transparent;
    padding: 10px 10px 33px 10px;
}

.group[data-level="2"] {
    background-color: #22465A;
}

.group[data-level="2"].is-over {
    background-color: #082534;
}

.group[data-level="3"] {
    background-color: #1B3848;
}

.group[data-level="3"].is-over {
    background-color: #082534;
}

.group[data-level="4"] {
    background-color: #162D3A;
}

.group[data-level="4"].is-over {
    background-color: #082534;
}

.group-button {
    position: absolute;
    user-select: none;
    bottom: -20px;
    left: 50%;
    margin-left: -20px;
    width: 40px;
    height: 40px;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    line-height: 36px;
    background-color: rgba(255, 255, 255, 0.15);
    background-color: #082534;
    color: #fff;
    font-size: 14px;
    z-index: 2;
    border: 2px solid #2b5870;
}

.group[data-level="1"] > .group-button {
    background-color: #4B7185;
}

.group[data-level="2"] .group-button {
    border-color: #2b5870;
}

.group[data-level="2"] > .group-button {
    background-color: #204254;
}

.group[data-level="3"] .group-button {
    border-color: #22465A;
}

.group[data-level="2"].is-over .group[data-level="3"] > .group-button {
    border-color: #082534;
}

.group[data-level="3"] > .group-button {
    background-color: #1B3848;
}

.group[data-level="4"] .group-button {
    border-color: #1B3848;
}

.group[data-level="3"].is-over .group[data-level="4"] > .group-button {
    border-color: #082534;
}

.group[data-level="4"] > .group-button {
    background-color: #22465A;
}

.group-button:hover {
    color: #fff;
    background-color: #082534!important;
    cursor: pointer;
}

.group[data-level="1"] >>> .logic .logic-type {
    background-color: #4B7185;
}

.group[data-level="1"] >>> .logic:after {
    border-color: #4B7185;
}

.group[data-level="2"] >>> .logic .logic-type {
    background-color: #436273;
}

.group[data-level="2"] >>> .logic:after {
    border-color: #436273;
}

.group[data-level="3"] >>> .logic .logic-type {
    background-color: #3D5663;
}

.group[data-level="3"] >>> .logic:after {
    border-color: #3D5663;
}

.group[data-level="1"] > .group-button:after {
    content: '';
    display: block;
    position: absolute;
    top: -15px;
    height: 13px;
    left: 50%;
    margin-left: -1px;
    border: 1px dashed #4B7185;
    z-index: 1;
}

.group-dropdown {
    margin-top: 20px;
}

</style>
